import { ArrowRight, OpenInNew } from "@mui/icons-material";
import { Popover } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import DiscordIcon from "../../assets/images/icons/DiscordIcon.tsx";
import MailIcon from "../../assets/images/icons/MailIcon.tsx";
import SlackIcon from "../../assets/images/icons/SlackIcon.tsx";
import { StyledMenuItem } from "../../components/common/BriaDropDown/BriaDropDown.tsx";
import LinkConstants from "../../constants/LinkConstants.ts";
import styles from "./Sidebar.module.scss";
import SidebarButton from "./SidebarButton.tsx";

const CommunityButton = () => {
	const { t } = useTranslation("translation", { keyPrefix: "sideMenu" });
	const [anchorEl, setAnchorEl] = useState<SVGSVGElement>();

	const handleOpenPopover = (event: React.MouseEvent<SVGSVGElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClosePopover = () => {
		setAnchorEl(undefined);
	};
	return (
		<>
			<SidebarButton
				onClick={handleOpenPopover}
				title={t("community")}
				iconStart={MailIcon}
				iconEnd={ArrowRight as any}
				selected={!!anchorEl}
				fullWidth={false}
			/>
			<Popover
				open={!!anchorEl}
				onClose={handleClosePopover}
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: "center",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "center",
					horizontal: "left",
				}}
				slotProps={{ paper: { className: styles.popover } }}
			>
				<StyledMenuItem
					className={styles.popoverItem}
					onClick={() => window.open(LinkConstants.SLACK_API_COMMUNITY)}
				>
					<SlackIcon />
					{t("slack")}
					<OpenInNew />
				</StyledMenuItem>
				<StyledMenuItem
					className={styles.popoverItem}
					onClick={() => window.open(LinkConstants.DISCORD_COMMUNITY)}
				>
					<DiscordIcon />
					{t("discord")}
					<OpenInNew />
				</StyledMenuItem>
			</Popover>
		</>
	);
};

export default observer(CommunityButton);
